import { useRemoteComponent } from '@instructure/quiz-core';
import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
export function QuizGenerationModal(_ref) {
  var onModalStateChange = _ref.onModalStateChange,
    loadRemoteModule = _ref.loadRemoteModule,
    modalConfig = _ref.modalConfig;
  var _useRemoteComponent = useRemoteComponent(loadRemoteModule, {
      context: {
        region: modalConfig.region || 'dev',
        open: modalConfig.open || false,
        onDismiss: modalConfig.onDismiss,
        onCompleted: modalConfig.onSubmit,
        getJWT: modalConfig.getJWT,
        productName: 'NewQuizzes'
      }
    }),
    modalComponentRef = _useRemoteComponent.containerRef,
    modalActivityState = _useRemoteComponent.componentActivityState,
    unmountModal = _useRemoteComponent.unmount;
  useEffect(function () {
    return function () {
      unmountModal();
    };
  }, [unmountModal]);
  useEffect(function () {
    onModalStateChange === null || onModalStateChange === void 0 || onModalStateChange(modalActivityState);
  }, [modalActivityState]);
  return /*#__PURE__*/React.createElement("div", {
    ref: modalComponentRef
  });
}
export var quizGenerationRegionType = PropTypes.oneOf(['prod-sin', 'prod-syd', 'prod-yul', 'prod-fra', 'prod-dub', 'prod-iad', 'prod-pdx', 'local', 'dev']);
QuizGenerationModal.propTypes = {
  onModalStateChange: PropTypes.func,
  loadRemoteModule: PropTypes.func,
  modalConfig: PropTypes.shape({
    open: PropTypes.bool,
    region: quizGenerationRegionType,
    getJWT: PropTypes.func,
    onSubmit: PropTypes.func,
    onDismiss: PropTypes.func
  }).isRequired
};